import { render, staticRenderFns } from "./HandlerInfo.vue?vue&type=template&id=1c1a5b1c&scoped=true"
import script from "./HandlerInfo.vue?vue&type=script&lang=js"
export * from "./HandlerInfo.vue?vue&type=script&lang=js"
import style0 from "./HandlerInfo.vue?vue&type=style&index=0&id=1c1a5b1c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1a5b1c",
  null
  
)

export default component.exports